export default __webpack_public_path__ + "static/media/demo-4-raw.c9d5ff62.jpg";